const SchoolDress = () => {
    return (
        <div id="dress" className="vision-card">

            <h3>SCHOOL DRESS</h3>

            <p>Boys: White Shirt, Navy Pant, Tie, Belt, Black Shoes</p>
            <p>Girls: White Shirt, Navy Skirt / Salwar Suit</p>
        </div>

    );
};

export default SchoolDress;